import request from '../utils/http'

const flowapis = {
    //查询流程列表
    getFlowList : query => {
        return request({
            url: '/flow/getFlowList',
            method: 'get',
            params:query
        });
    },
       //查询流程
       getFlowById : query => {
        return request({
            url: '/flow/getFlowById',
            method: 'get',
            params:query
        });
    },
    getFlowListCaseWordTemp : query => {
      return request({
          url: '/flow/getFlowListCaseWordTemp',
          method: 'get',
          params: query
      })
    },
    getBookById : query => {
        return request({
            url: '/standingBook/getBookById',
            method: 'get',
            params: query
        });
    },
      //修改银行
      updateFlow : query => {
        return request({
            url: '/flow/updateFlow',
            method: 'post',
            data: query
        });
    },
       //查询经理
       getUserListForAudit : query => {
        return request({
            url: '/user/getUserListForAudit',
            method: 'get',
            params:query
        });
    },
      //修改审核人员
      updateFlowMananger : query => {
        return request({
            url: '/flow/updateFlowMananger',
            method: 'post',
            data: query
        });
    },
     //接受流程
     receiveFlow : query => {
        return request({
            url: '/flow/receiveFlow',
            method: 'post',
            data: query
        });
    },
    //添加流程文件
    addLoanFile : query => {
        return request({
            url: '/loanFile/addLoanFile',
            method: 'post',
            data: query
        });
    },
    deleteLoanFile : query => {
        return request({
            url: '/loanFile/deleteLoanFile',
            method: 'post',
            data: query
        });
    },
    //查询流程文件
    getLoanFiles : query => {
        return request({
            url: '/loanFile/getLoanFiles',
            method: 'get',
            params:query
        });
    },
    //查询审核信息
    getLoanAuditInfo : query => {
        return request({
            url: '/flow/getLoanAuditInfo',
            method: 'get',
            params:query
        });
    },
    //保存审核信息
    saveAuditInfo : query => {
        return request({
            url: '/flow/saveAuditInfo',
            method: 'post',
            data: query
        });
    },
    saveAuditInfo2 : query => {
        return request({
            url: '/flow/saveAuditInfo2',
            method: 'post',
            data: query
        });
    },
     //查询担保列表
     getDBList : query => {
        return request({
            url: '/flow/getDBList',
            method: 'get',
            params:query
        });
    },
    //查询统计
    getFlowStatic : query => {
        return request({
            url: '/flow/getFlowStatic',
            method: 'get',
            params:query
        });
    },
    //查询Excel信息
    getExcelInfo : query => {
        return request({
            url: '/flow/getExcelInfo',
            method: 'get',
            params:query
        });
    },
    getFlowLogByFlowId:query=>{
        return request({
            url:'/flow/getFlowLogByFlowId',
            method:'get',
            params:query
        })
    },
    //下面是台账相关的内容
    getStandingBookList:query=>{
        return request({
            url:'/standingBook/getStandingBookList',
            method:'post',
            params:query
        })
    },
    //更新台账
    updateStandingBook:query=>{
        return request({
            url : '/standingBook/updateStandingBook',
            method:'post',
            data:query
        })
    },
    //获取去重之后的主调
    getFirstInquirerList:query=>{
        return request({
            url: '/standingBook/getFirstInquirerList',
            method:'get',
            params:query
        })
    },
    getStatisticSb:query=>{
        return request({
            url: '/standingBook/getStatisticSb',
            method:'get',
            params:query
        })
    },
    getDataFourByCondition:query=>{
        return request({
            url: '/standingBook/getDataFourByCondition',
            method:'get',
            params:query
        })
    },
    getStatisticSbTypeMonth:query=>{
      return request({
          url:'/standingBook/getStatisticSbTypeMonth',
          method:'get',
          params:query
      })
    },
    getStatisticSbTypeYear:query=>{
        return request({
            url:'/standingBook/getStatisticSbTypeYear',
            method:'get',
            params:query
        })
    },
    getStatisticBank: query => {
      return request({
          url: '/standingBook/getStatisticBank',
          method: 'post',
          data: query
      })
    },
    getStatisticSbCustom: query => {
        return request({
            url: '/standingBook/getStatisticSbCustom',
            method: 'post',
            data: query
        })
      },
    getAreaData: query => {
        return request({
            url: '/standingBook/getAreaSumData',
            method: 'post',
            data: query
        })
      },
      getDataReport:query=>{
        return request({
            url:'/standingBook/getDataReport',
            method:'post',
            data:query
        })
      },
    getProjectNameDistinct: query => {
      return request({
          url: '/standingBook/getProjectNameDistinct',
          method: 'get',
          params: query
      })
    },
    //获取去重之后的主调
    getDBTJInfo:query=>{
        return request({
            url: '/flow/getDBTJInfo',
            method:'get',
            params:query
        })
    },
    //获取去重之后的主调
    exportWord:query=>{
        return request({
            url: '/flow/exportWord',
            method:'post',
            data:query
        })
    },
    //确认生成担保函或者推荐函
    confirmComplWord:query=>{
        return request({
            url: '/flow/confirmComplWord',
            method:'post',
            data:query
        })
    },
        //确认生成担保函或者推荐函
        confirmComplWord2:query=>{
            return request({
                url: '/flow/confirmComplWord2',
                method:'post',
                data:query
            })
        },
    //导入Excel台账
    excelImport:query=>{
      return request({
          url: '/flow/excelImport',
          method:'post',
          data:query
      })
    },
    excelExport:query=>{
      return request({
          url:'/flow/excelExport',
          method:'post',
          params:query
      })
    },
    //获取去重之后的主调
    htExportWord:query=>{
        return request({
            url: '/exportWord/exportWord1',
            method:'post',
            data:query
        })
    },
        onFDDWord:query=>{
        return request({
            url: '/fdd/exportFddWord',
            method:'post',
            data:query
        })
    },

}


export default flowapis
